<template>
    <div>
        <div :class='{"in": openSwitch, "open": openSwitch}' class="modal fade">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="row">
                                <div class="col-md-12">
                                    <div v-if="!canOrderReward" class="no-address-alert alert-info">
                                        <h4 class="alert-heading">Bitte trag deine Adresse ein, um Gutscheine zu
                                            bestellen.</h4>
                                        <div class="address-not-set-warning-container">
                                            Um Gutscheine bestellen zu können, musst du deine Adresse angeben. Diese
                                            benötigen wir aus steuerechtlichen Gründen, um dir einen Gutschein auszahlen
                                            zu dürfen.
                                        </div>
                                        <div class="link-to-user-profile-btn">
                                            <router-link to="/profile">
                                                <button class="btn btn-primary to-user-profile-button">
                                                    Jetzt eintragen
                                                </button>
                                            </router-link>
                                        </div>
                                </div>
                                </div>
                            </div>
                    <div class="modal-body" style="padding: 4rem;">
                        <div v-if="userProfileApiResult.loaded && userProfileApiResult.error"
                             style="text-align: center">
                            <i style="font-size: 3rem; color: #cc2626;" class="dev-triangle-alert"></i>
                            <h3>Da ist etwas schiefgelaufen</h3>
                            <p>{{userProfileApiResult.error.message}}</p>
                        </div>
                        <div v-if="!userProfileApiResult.loaded" style="text-align: center">
                            <span class="loading-spinner loading-spinner-big loading-spinner-green"
                                  style="margin-bottom: 3rem; margin-top: 4rem;">
                            </span>
                        </div>
                        <div v-if="userProfileApiResult.loaded && !userProfileApiResult.error" >

                            <div class="row reward-description" :class="{noOrder : !canOrderReward}">
                                <div class="col-lg-3 col-md-3 col-xs-3 col-sm-3"></div>
                                <div class="reward-item-box col-md-6 col-lg-6 col-xs-12 col-sm-12" :class="{'col-centered': description === ''}">
                                    <div class="row">
                                        <div class="col-md-12 product-image" :style="getBackgroundImage()"></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <div v-if="rewards.length === 1" class="product-title">
                                              {{ rewards[0].title }}
                                            </div>
                                            <div v-if="rewards.length > 1" class="product-title">
                                              <select v-model="selectedReward">
                                                <option disabled :value="null">Bitte auswählen</option>
                                                <option v-for="reward in rewards" :value="reward.id">{{ reward.title }} - {{ reward.price }} Coins</option>
                                              </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div v-if="selectedReward || rewards.length === 1" class="price-value">
                                          <strong>Preis: {{selectedRewardPrice}} <img src="/assets/img/coins.png" style="height: 1.2rem"/></strong>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div v-if="selectedReward && outOfStock" class="not-available">Zur Zeit leider nicht verfügbar!</div>
                                        <div v-if="selectedReward && !rewardIsUnlimited && !outOfStock" class="limited-available">Nur noch {{ rewardAmount }} verfügbar!</div>
                                        <div v-if="selectedReward && rewardIsUnlimited" class="available">Verfügbar</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <p class="col-md-12" v-html="description"></p>
                            </div>
                            <hr/>
                            <div class="row">
                                <div class="col-md-12 text-center">
                                  <div v-if="getRemainingUserCoins(userCoinsApiResult.coins, selectedRewardPrice) < 0" class="alert alert-danger">
                                    Du hast leider nicht genug Coins für diesen Reward!
                                  </div>
                                    <button class="btn btn-secondary btn-margin" @click="close">Abbrechen</button>
                                    <button :disabled="!hasChosenReward || getRemainingUserCoins(userCoinsApiResult.coins, selectedRewardPrice) < 0 || outOfStock || !canOrderReward" class="btn btn-primary btn-margin" @click="exchangeReward">
                                      <span v-if="this.selectedReward">Gegen {{selectedRewardPrice}} <img src="/assets/img/coins.png" style="height: 1.2rem"/> tauschen</span>
                                      <span v-if="!this.selectedReward">Bitte Option auswählen!</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-if="isRewardExchangedTriggered"
                             style="position: absolute; left: 0; top:0; background-color: rgba(255,255,255,0.9); width: 100%; height: 100%; padding: 5rem; text-align: center">

                            <div v-if="hasLoaded">
                                <svg style="margin-bottom: 3rem; margin-top: 4rem;" class="checkmark"
                                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                    <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"></circle>
                                    <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"></path>
                                </svg>
                                <h3>Umtausch erfolgreich!</h3>
                                <button class="btn btn-primary" @click="close">Schließen</button>
                            </div>

                            <div v-if="!hasLoaded">
                            <span class="loading-spinner loading-spinner-green loading-spinner-big"
                                  style="color: rgba(0,0,0,0.4); margin-bottom: 3rem; margin-top: 4rem;">
                            </span>
                                <h3>Umtausch ist in Bearbeitung!</h3>
                            </div>
                        </div>
                    </div>
                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->

        </div><!-- /.modal -->
        <div v-if="openSwitch" class="modal-backdrop fade in"></div>
    </div>
</template>

<script>
    import {services} from "../../main.js"
    import {eventBus} from "../../main.js"
    import UserCoinsComponent from "./UserCoinsComponent";


    export default {
        name: "RewardExchangeView",
        components: {UserCoinsComponent},
        props: {
            uuid: {type: [String], default: ''},
            title: {type: [String], default: ''},
            description: {type: [String], default: ''},
            logo: {type: [String], default: null},
            minPrice: {type: [Number], default: 0},
            maxPrice: {type: [Number], default: 0},
            rewards: {type: [Array], default: () => []},
            openSwitch: {type: [Boolean], default: false},
            closeHandler: {
                type: [Function], default: function () {
                }
            },

        },
        data() {
            return {
                apiResultExchange: {loaded: false},
                isRewardExchangedTriggered: false,
                userCoinsApiResult: services.rewardService.getUserCoins(),
                userProfileApiResult: services.userService.getUserProfile(),
                selectedReward: null
            }
        },
        mounted() {

        },
        computed: {
            rewardIsUnlimited() {
              for (let reward of this.rewards) {
                  if (reward.id === this.selectedReward) {
                    return reward.amountOfRewards === null;
                  }
              }
            },
            outOfStock() {
              for (let reward of this.rewards) {
                  if (reward.id === this.selectedReward) {
                    if (reward.remainingRewards === null) {
                      return false;
                    }
                    return (reward.remainingRewards <= 0 );
                  }
              }
            },
            rewardAmount() {
              if (!this.rewardIsUnlimited) {
                for (let reward of this.rewards) {
                  if (reward.id === this.selectedReward) {
                    return reward.remainingRewards;
                  }
                }
              }
              return 0;
            },
            hasLoaded() {
                return this.apiResultExchange.loaded;
            },
            userAddress() {
                return {
                    lastName: this.userProfileApiResult.user_profile.last_name,
                    firstName: this.userProfileApiResult.user_profile.first_name,
                    address: this.userProfileApiResult.user_profile.address,
                    city: this.userProfileApiResult.user_profile.city,
                    zipCode: this.userProfileApiResult.user_profile.zipCode,
                    country: this.userProfileApiResult.user_profile.country,
                }
            },
            canOrderReward() {
                if (!this.userProfileApiResult.loaded || this.userProfileApiResult.error ) {
                    return true;
                }
                return (
                    this.userProfileApiResult.user_profile.first_name &&
                    this.userProfileApiResult.user_profile.last_name &&
                    this.userProfileApiResult.user_profile.city &&
                    this.userProfileApiResult.user_profile.address &&
                    this.userProfileApiResult.user_profile.zipCode &&
                    this.userProfileApiResult.user_profile.country
                )
            },
            hasChosenReward() {
              if(this.rewards.length === 1) {
                this.selectedReward = this.rewards[0].id;
              }
              return this.selectedReward !== null;
            },
            selectedRewardPrice() {
              for (const reward of this.rewards) {
                if (reward.id === this.selectedReward) {
                  return reward.price;
                }
              }
              return 0;
            }
        },
        watch: {
            hasLoaded: function (hasLoaded) {
                if (hasLoaded) {
                    eventBus.$emit('user-coins-changed');
                }
            }
        },
        methods: {
            getBackgroundImage() {
                return 'background-image: url("' + this.logo + '");'
            },
            getRemainingUserCoins(userCoins, price) {
                return userCoins - price;
            },
            exchangeReward() {
                this.isRewardExchangedTriggered = true;
                const contactEmailAddress = this.userProfileApiResult.user_profile.contact_email_address;
                this.apiResultExchange = services.rewardService.exchangeReward(this.selectedReward, contactEmailAddress, this.userAddress)
            },
            close() {
                if(this.hasLoaded){
                  eventBus.$emit('reload-reward-list');
                }
                this.closeHandler();
                Object.assign(this.$data, this.$options.data());
            }
        }
    }
</script>

<style scoped>
    .available {
      color: #08AB99;
    }

    .limited-available, .not-available {
      color: #e74c3c;
    }

    .price-value {
      margin-bottom: .5rem;
    }

    .open {
        display: block;
    }

    .no-address-alert {
        margin-bottom: 15px;
        text-align: center;
    }

    .to-user-profile-button {
        margin-top: 5px;
    }

    .product-image {
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        height: 120px;
    }

    .reward-item-box {
        box-shadow: 0 10px 50px rgba(50, 50, 93, .1), 0 5px 10px rgba(0, 0, 0, .25);
        text-align: center;
        background: linear-gradient(45deg, #fff, #eeeeee);
        border-radius: 8px;
        padding: 3rem;
        margin: 0;
        margin-bottom: 1rem;
    }

    .reward-description {
        margin-bottom: 2rem;
    }

    .product-title {
        margin: 1rem 0;
        font-size: 1.8rem;
    }

    .product-title select {
      padding: .5rem;
      border-radius: 7px;
      background-color: var(--button-hover-background);
      border: none;
    }

    .product-title select:focus-visible {
      outline: none;
    }

    .calculation {
        text-align: right;
    }

    @media (max-width: 979px) {
        .calculation {
            text-align: center;
        }
    }

    /* animated checkmark */
    .checkmark__circle {
        stroke-dasharray: 166;
        stroke-dashoffset: 166;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke: #08AB99;
        fill: none;
        animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
    }

    .checkmark {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        display: block;
        stroke-width: 2;
        stroke: #fff;
        stroke-miterlimit: 10;
        margin: 10% auto;
        box-shadow: inset 0px 0px 0px #08AB99;
        animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
    }

    .checkmark__check {
        transform-origin: 50% 50%;
        stroke-dasharray: 48;
        stroke-dashoffset: 48;
        animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
    }

    @keyframes stroke {
        100% {
            stroke-dashoffset: 0;
        }
    }

    @keyframes scale {
        0%, 100% {
            transform: none;
        }
        50% {
            transform: scale3d(1.1, 1.1, 1);
        }
    }

    @keyframes fill {
        100% {
            box-shadow: inset 0 0 0 30px #08AB99;
        }
    }

    .col-centered {
        float: none;
        margin: 0 auto;
    }

    .noOrder {
        filter: saturate(0) brightness(110%);
    }

    @media (min-width: 768px) {
        .modal-dialog {
            width: 740px;
            margin: 30px auto;
        }
}
</style>
